import { InputMaskChangeEvent } from 'primereact/inputmask';
import { UseFormRegisterReturn } from 'react-hook-form/dist/types';

export type SearchBarProps = {
  placeholder: string;
  searchBarStyle?: string;
  className?: string;
  type?: string;
  handleChange?: (
    e: React.ChangeEvent<HTMLInputElement> | InputMaskChangeEvent,
  ) => void;
  register?: UseFormRegisterReturn;
  value?: string;
  maxLength?: number;
  onClick?: () => void;
};

export enum Type {
  TEXT = 'text',
  TEL = 'tel',
}
